import React from 'react';
import { Header, Footer } from '../../components';
import './side-nav-outer-toolbar.scss';

export default function SideNavOuterToolbar({ title, children }) {
  return (
    <div className="side-nav-outer-toolbar">
      <Header title={title} />
      <div className="content">{children}</div>
      <Footer />
    </div>
  );
}
